import { useEffect, useState } from 'react'
import { useClient } from 'sanity'

export default function useFileName(id?: string): string | null {
  const [fileName, setFileName] = useState<string | null>(null)
  const client = useClient()

  useEffect(() => {
    if (!id) {
      setFileName(null)
      return
    }

    client
      .fetch<{ originalFilename?: string }>(`*[_id == $id][0]`, { id })
      .then((image) => {
        setFileName(image?.originalFilename || null)
      })
      .catch((error) => {
        console.error('Error fetching filename:', error)
        setFileName(null)
      })
  }, [id, client])

  return fileName
}